import React from 'react';
import { NavLink } from 'react-router-dom';
import { useState } from "react";

const BurgerMenu = () => {
    const[showLinks, setShowLinks] = useState(false)

    const handleShowLink = () => {
        setShowLinks(!showLinks);
        let burger = document.querySelector(".burger_bar");
        burger.classList.toggle("open_close");
    }

    return (
        <div className="burger_menu">
            <button className="navbar_burger" onClick={handleShowLink}>
                <span className="burger_bar"></span>
            </button>
            <div className={`navbar ${showLinks ? "popup" : "popup show-nav"}`}>
                <ul>
                    <NavLink to="/accueil" exact className="hover" activeClassName="nav-active">
                        <li>Accueil</li>
                    </NavLink>
                    <NavLink to="/realisations" exact className="hover" activeClassName="nav-active">
                        <li>Réalisations</li>
                    </NavLink>
                    <NavLink to="/contact" exact className="hover" activeClassName="nav-active">
                        <li>Contact</li>
                    </NavLink> 
                </ul> 
                
            </div>
            
        </div>
    ); 
};

export default BurgerMenu;